<template>
  <div class="ezd-page">
    <div class="title thirdNav_box">
      <!-- <span>请选择位置：</span> -->
      <ul>
        <li
          v-for="(nav, index) in navList"
          :key="index"
          :class="{ active: choiceNav === nav }"
          @click="choiceNavHandel(nav)"
        >
          {{ nav }}
        </li>
      </ul>
    </div>
    <div class="content">
      <table
        :class="{ line1: number <= 5 }"
        v-for="number in 10"
        :key="number + '-label'"
        cellpadding="0"
        cellspacing="0"
      >
        <thead class="">
          <!-- <th class="bold">号码</th>
          <th class="bold">赔率</th>
          <th class="bold">金额</th> -->
        </thead>
        <tbody>
          <tr
            class="ball-td"
            :class="{ active: odds.isChecked }"
            style="cursor: pointer"
            @click="choiceBall(odds)"
            v-for="(odds, index) in oddsList[choiceNav].list.slice(
              10 * (number - 1),
              10 * number
            )"
            :key="odds.number"
          >
            <td style="width: 80px" class="center bold">
              <div
                class="arrow"
                @click.stop="quickChoice('table', number)"
              ></div>
              {{ odds.number }}
            </td>
            <td
              :class="{ bc_ball: odds.isChecked }"
              class="center bold"
              :style="`width: 50px; color: ${
                odds.isChecked
                  ? 'var(--new-text-primary-bg)'
                  : 'var(--new-text-bet-ezd)'
              }`"
            >
              {{ isClose == 0 ? odds.peilv : "--" }}
            </td>
            <td
              class="center"
              :class="{ bc_ball: odds.isChecked }"
              style="
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
              "
            >
              <input
                oninput="value=value.replace(/[^\d]/, '')"
                @click.stop
                @focus="choiceBall(odds, true)"
                @keyup.enter="confirmBet()"
                class="input"
                :disabled="isClose == 1"
                :readonly="isClose == 1"
                style="
                  width: 50px;
                  height: 18px;
                  line-height: 13px;
                  font-size: 12px;
                  color: var(--new-text);
                  border-radius: 4px;
                  vertical-align: text-top;
                  text-align: center;
                  background: var(--new-bg-white);
                "
                type="text"
                v-model="odds.money"
              />
              <!-- <span
                v-else
                style="
                  display: inline-block;
                  width: 48px;
                  height: 18px;
                  font-size: 12px;
                  border: 1px solid #aaa;
                  color: #aaa;
                  border-radius: 2px;
                "
              >
                封盘
              </span> -->
              <!-- <i
                v-show="odds.isChecked"
                style="
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  right: 2px;
                  fotn-size: 16px;
                  color: #bddf0a;
                "
                class="el-icon-circle-check"
              ></i> -->
            </td>
            <div
              class="arrow"
              v-if="number < 6"
              @click.stop="quickChoice('line', index)"
            ></div>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tool-wrapper">
      <div class="tool">
        <div class="tool-title">定位置</div>
        <div class="tool-content">
          <div class="row">
            <div class="bc">{{ firstText }}</div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('0') }"
                @click="choiceNumber('0', 1)"
                >0</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('1') }"
                @click="choiceNumber('1', 1)"
                >1</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('2') }"
                @click="choiceNumber('2', 1)"
                >2</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('3') }"
                @click="choiceNumber('3', 1)"
                >3</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('4') }"
                @click="choiceNumber('4', 1)"
                >4</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('5') }"
                @click="choiceNumber('5', 1)"
                >5</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('6') }"
                @click="choiceNumber('6', 1)"
                >6</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('7') }"
                @click="choiceNumber('7', 1)"
                >7</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('8') }"
                @click="choiceNumber('8', 1)"
                >8</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('9') }"
                @click="choiceNumber('9', 1)"
                >9</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('big') }"
                @click="choiceNumber('big', 1)"
                >大</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('small') }"
                @click="choiceNumber('small', 1)"
                >小</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('single') }"
                @click="choiceNumber('single', 1)"
                >单</span
              >
            </div>
            <div>
              <span
                :class="{ active: firstPositionFilter.includes('double') }"
                @click="choiceNumber('double', 1)"
                >双</span
              >
            </div>
          </div>
          <div class="row">
            <div class="bc">{{ secondText }}</div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('0') }"
                @click="choiceNumber('0', 2)"
                >0</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('1') }"
                @click="choiceNumber('1', 2)"
                >1</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('2') }"
                @click="choiceNumber('2', 2)"
                >2</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('3') }"
                @click="choiceNumber('3', 2)"
                >3</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('4') }"
                @click="choiceNumber('4', 2)"
                >4</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('5') }"
                @click="choiceNumber('5', 2)"
                >5</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('6') }"
                @click="choiceNumber('6', 2)"
                >6</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('7') }"
                @click="choiceNumber('7', 2)"
                >7</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('8') }"
                @click="choiceNumber('8', 2)"
                >8</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('9') }"
                @click="choiceNumber('9', 2)"
                >9</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('big') }"
                @click="choiceNumber('big', 2)"
                >大</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('small') }"
                @click="choiceNumber('small', 2)"
                >小</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('single') }"
                @click="choiceNumber('single', 2)"
                >单</span
              >
            </div>
            <div>
              <span
                :class="{ active: secondPositionFilter.includes('double') }"
                @click="choiceNumber('double', 2)"
                >双</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="tool">
        <div class="tool-title">合分</div>
        <div class="tool-content">
          <div class="row">
            <div>
              <span
                :class="{ active: heFenFilter.includes('0') }"
                @click="choiceHeFen('0')"
                >0</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('1') }"
                @click="choiceHeFen('1')"
                >1</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('2') }"
                @click="choiceHeFen('2')"
                >2</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('3') }"
                @click="choiceHeFen('3')"
                >3</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('4') }"
                @click="choiceHeFen('4')"
                >4</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('single') }"
                @click="choiceHeFen('single')"
                >单</span
              >
            </div>
            <div
              class="bc"
              style="border-left: 1px solid var(--primary-table-border-color)"
            >
              <span style="white-space: nowrap; background: none; width: unset"
                >{{ firstText }}位：</span
              >
              <input
                class="input"
                oninput="value=value.replace(/[^\d]/, '')"
                style="width: 120px"
                type="text"
                v-model="firstFilterInput"
              />
            </div>
          </div>
          <div class="row">
            <div>
              <span
                :class="{ active: heFenFilter.includes('5') }"
                @click="choiceHeFen('5')"
                >5</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('6') }"
                @click="choiceHeFen('6')"
                >6</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('7') }"
                @click="choiceHeFen('7')"
                >7</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('8') }"
                @click="choiceHeFen('8')"
                >8</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('9') }"
                @click="choiceHeFen('9')"
                >9</span
              >
            </div>
            <div>
              <span
                :class="{ active: heFenFilter.includes('double') }"
                @click="choiceHeFen('double')"
                >双</span
              >
            </div>
            <div
              class="bc"
              style="border-left: 1px solid var(--primary-table-border-color)"
            >
              <span style="white-space: nowrap; background: none; width: unset"
                >{{ secondText }}位：</span
              >
              <input
                class="input"
                oninput="value=value.replace(/[^\d]/, '')"
                style="width: 120px"
                type="text"
                v-model="secondFilterInput"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom—tool">
      <div style="position: relative" v-clickoutside="handleClickoutside">
        <span class="btn primary" @click="handleShowPreMoney()">快选金额</span>
        <ul
          v-show="showPreMoney"
          style="
            position: absolute;
            bottom: 25px;
            left: 0;
            right: 0;
            background: #fff;
            border: 1px solid #bad4e8;
            border-radius: 5px;
            box-shadow: rgb(204, 204, 204) 2px 2px 5px;
          "
        >
          <li
            style="padding: 5px 10px"
            v-for="(item, index) in preMoney"
            :key="index"
          >
            <input
              class="input"
              style="
                padding: 5px;
                width: 50px;
                height: 25px;
                border-radius: 2px;
              "
              type="text"
              v-model="preMoney[index]"
            />
          </li>
          <li style="padding: 5px 10px">
            <input
              class="btn primary"
              type="button"
              value="确认"
              @click="surePreMoney()"
            />
          </li>
        </ul>
      </div>
      <div style="margin-left: 40px; margin-right: 20px">
        <span
          v-for="(item, index) in showPreMoneyList"
          :key="index"
          @click="money = item"
          class="choice-money"
          :class="{ active: money == item }"
        >
          {{ item }}
        </span>
      </div>
      <!-- <el-checkbox />
      <span style="margin-right: 7px">预设</span> -->
      <span class="bold active-text" style="margin-right: 8px">下注金额</span>
      <input
        class="input-money input"
        @keyup.enter="confirmBet()"
        oninput="value=value.replace(/[^\d | ^.]/g,'').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')"
        type="text"
        v-model="money"
      />

      <div class="btn-group">
        <input class="btn circle" type="button" value="重填" @click="reset()" />
        <input
          class="btn primary"
          type="button"
          value="提交"
          @click="confirmBet()"
        />
      </div>
    </div>

    <div class="confirm-bet-wrapper" v-show="showComfirmBet">
      <div
        class="confirm-bet"
        tabindex="0"
        ref="confirmBet"
        @keyup.enter.capture="bet()"
      >
        <h1 class="title">
          确认下单<i class="el-icon-close" @click="showComfirmBet = false"></i>
        </h1>
        <div class="content">
          <table cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th>注单明细</th>
                <th>赔率</th>
                <th>下注金额</th>
                <th>操作</th>
                <th>打印</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in betList" :key="index">
                <td style="width: 120px">{{ item.number }}</td>
                <td style="width: 80px">{{ item.peilv }}</td>
                <td style="width: 120px">
                  <input
                    class="money"
                    type="text"
                    v-model="betList[index].money"
                  />
                </td>
                <td style="width: 80px">
                  <div class="del-bet" @click="delBetList(index)">
                    <i class="el-icon-close"></i>
                  </div>
                </td>
                <td style="width: 80px">
                  <el-checkbox v-model="item.printChecked" />
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <div
                    style="
                      color: var(--new-text-info);
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <div style="width: 120px; text-align: center">
                      总注数：<span>{{ betList.length }}</span
                      >笔
                    </div>
                    <div style="width: 160px; text-align: center">
                      合计金额：{{ sum(betList, "money") }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="btn-group">
          <input
            style="width: 100px"
            class="btn info"
            type="button"
            value="取消"
            @click="showComfirmBet = false"
          />
          <input
            style="width: 100px"
            class="btn primary"
            type="button"
            value="确认"
            @click="bet()"
          />
        </div>
        <div
          class="tips"
          style="
            margin: 17px 0 20px;
            text-align: center;
            font-size: 12px;
            color: var(--new-text-info);
          "
        >
          赔率变化，按最新赔率投注，不提示赔率变
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Clickoutside from "element-ui/src/utils/clickoutside";
export default {
  data() {
    return {
      timer: null,
      playcode: "D2W",
      showComfirmBet: false,
      showPreMoney: false,
      choiceNav: "口口XX",
      money: "",
      betList: [],
      firstFilterInput: "",
      secondFilterInput: "",
      firstPositionFilter: [],
      secondPositionFilter: [],
      heFenFilter: [],
      showPreMoneyList: ["50", "100", "200", "500", "1000"],
      preMoney: ["50", "100", "200", "500", "1000"],
      navList: [
        "口口XX",
        "口X口X",
        "口XX口",
        "X口口X",
        "X口X口",
        "XX口口",
        "口XXX口",
        "X口XX口",
        "XX口X口",
        "XXX口口",
      ],
      oddsList: {
        口口XX: {
          list: [],
        },
        口X口X: {
          list: [],
        },
        口XX口: {
          list: [],
        },
        X口口X: {
          list: [],
        },
        X口X口: {
          list: [],
        },
        XX口口: {
          list: [],
        },
        口XXX口: {
          list: [],
        },
        X口XX口: {
          list: [],
        },
        XX口X口: {
          list: [],
        },
        XXX口口: {
          list: [],
        },
      },
      quickChoiceList: {},
    };
  },
  props: ["initFinished", "isClose"],
  directives: {
    Clickoutside,
  },
  watch: {
    isClose(newVal) {
      if (newVal == 0) {
        this.getBetList();
      } else {
        Object.values(this.oddsList).forEach((item) => {
          item.list.forEach((i) => (i.money = "封盘"));
        });
      }
    },
    initFinished() {
      this.initData();
    },
    money(newVal) {
      if (newVal !== "") {
        this.setCheckedMoney();
      }
    },
    choiceNav() {
      this.checkNumebrByToolBtn();
      this.setCheckedMoney();
    },
    firstPositionFilter() {
      this.checkNumebrByToolBtn();
      this.setCheckedMoney();
    },
    secondPositionFilter() {
      this.checkNumebrByToolBtn();
      this.setCheckedMoney();
    },
    heFenFilter() {
      this.checkNumebrByToolBtn();
      this.setCheckedMoney();
    },
    firstFilterInput() {
      this.checkNumebrByToolBtn();
      this.setCheckedMoney();
    },
    secondFilterInput() {
      this.checkNumebrByToolBtn();
      this.setCheckedMoney();
    },
  },
  mounted() {
    this.initData();
  },
  computed: {
    firstText() {
      let str = "";
      switch (this.choiceNav) {
        case "口口XX":
          str = "万";
          break;
        case "口X口X":
          str = "万";
          break;
        case "口XX口":
          str = "万";
          break;
        case "X口口X":
          str = "千";
          break;
        case "X口X口":
          str = "千";
          break;
        case "XX口口":
          str = "百";
          break;
        case "口XXX口":
          str = "万";
          break;
        case "X口XX口":
          str = "千";
          break;
        case "XX口X口":
          str = "百";
          break;
        case "XXX口口":
          str = "十";
          break;
      }
      return str;
    },
    secondText() {
      let str = "";
      switch (this.choiceNav) {
        case "口口XX":
          str = "千";
          break;
        case "口X口X":
          str = "百";
          break;
        case "口XX口":
          str = "十";
          break;
        case "X口口X":
          str = "百";
          break;
        case "X口X口":
          str = "十";
          break;
        case "XX口口":
          str = "十";
          break;
        case "口XXX口":
          str = "个";
          break;
        case "X口XX口":
          str = "个";
          break;
        case "XX口X口":
          str = "个";
          break;
        case "XXX口口":
          str = "个";
          break;
      }
      return str;
    },
  },
  methods: {
    initData() {
      this.getBetList();
    },
    quickChoice(type, lineNumber) {
      if (type === "table") {
        // 选中一整个table
        const arr = this.oddsList[this.choiceNav].list.slice(
          10 * (lineNumber - 1),
          10 * lineNumber
        );
        let checked = false;
        const key = `${type}-${lineNumber}`;
        if (this.quickChoiceList[key] === undefined) {
          checked = true;
          this.$set(this.quickChoiceList, key, checked);
        } else {
          checked = !this.quickChoiceList[key];
          this.$set(this.quickChoiceList, key, checked);
        }
        arr.forEach((ball) => this.choiceBall(ball, checked));
      } else if (type === "line") {
        // 选中两行
        const arr = [];
        for (let number = 1; number <= 10; number++) {
          arr.push(
            this.oddsList[this.choiceNav].list.slice(
              10 * (number - 1),
              10 * number
            )[lineNumber]
          );
        }
        let checked = false;
        const key = `${type}-${lineNumber}`;
        if (this.quickChoiceList[key] === undefined) {
          checked = true;
          this.$set(this.quickChoiceList, key, checked);
        } else {
          checked = !this.quickChoiceList[key];
          this.$set(this.quickChoiceList, key, checked);
        }
        arr.forEach((ball) => this.choiceBall(ball, checked));
      }
    },
    handleClickoutside() {
      this.showPreMoney = false;
    },
    handleShowPreMoney() {
      this.showPreMoney = !this.showPreMoney;
    },
    checkNumebrByToolBtn() {
      this.oddsList[this.choiceNav].list.forEach((item) => {
        item.isChecked = false;
      });

      //按位置勾选
      if (
        this.firstPositionFilter.length > 0 &&
        this.secondPositionFilter.length > 0
      ) {
        for (let odds of this.oddsList[this.choiceNav].list) {
          for (let first of this.firstPositionFilter) {
            for (let second of this.secondPositionFilter) {
              let number = odds.number.replace(/X/g, "");
              let firstNumber = number.substr(0, 1) * 1;
              let secondNumber = number.substr(1, 1) * 1;
              let reg = /[0-9]/i;
              if (!reg.test(first) || !reg.test(second)) {
                if (!reg.test(first) && reg.test(second)) {
                  if (secondNumber == second) {
                    if (first === "big") {
                      if (firstNumber >= 5) {
                        odds.isChecked = true;
                      }
                    } else if (first === "small") {
                      if (firstNumber < 5) {
                        odds.isChecked = true;
                      }
                    } else if (first === "single") {
                      if (firstNumber % 2 !== 0) {
                        odds.isChecked = true;
                      }
                    } else if (first === "double") {
                      if (firstNumber % 2 === 0) {
                        odds.isChecked = true;
                      }
                    }
                  }
                } else if (reg.test(first) && !reg.test(second)) {
                  if (firstNumber == first) {
                    if (second === "big") {
                      if (secondNumber >= 5) {
                        odds.isChecked = true;
                      }
                    } else if (second === "small") {
                      if (secondNumber < 5) {
                        odds.isChecked = true;
                      }
                    } else if (second === "single") {
                      if (secondNumber % 2 !== 0) {
                        odds.isChecked = true;
                      }
                    } else if (second === "double") {
                      if (secondNumber % 2 === 0) {
                        odds.isChecked = true;
                      }
                    }
                  }
                } else if (!reg.test(first) && !reg.test(second)) {
                  if (first === "big") {
                    if (firstNumber >= 5) {
                      if (second === "big") {
                        if (secondNumber >= 5) {
                          odds.isChecked = true;
                        }
                      } else if (second === "small") {
                        if (secondNumber < 5) {
                          odds.isChecked = true;
                        }
                      } else if (second === "single") {
                        if (secondNumber % 2 !== 0) {
                          odds.isChecked = true;
                        }
                      } else if (second === "double") {
                        if (secondNumber % 2 === 0) {
                          odds.isChecked = true;
                        }
                      }
                    }
                  } else if (first === "small") {
                    if (firstNumber < 5) {
                      if (second === "big") {
                        if (secondNumber >= 5) {
                          odds.isChecked = true;
                        }
                      } else if (second === "small") {
                        if (secondNumber < 5) {
                          odds.isChecked = true;
                        }
                      } else if (second === "single") {
                        if (secondNumber % 2 !== 0) {
                          odds.isChecked = true;
                        }
                      } else if (second === "double") {
                        if (secondNumber % 2 === 0) {
                          odds.isChecked = true;
                        }
                      }
                    }
                  } else if (first === "single") {
                    if (firstNumber % 2 !== 0) {
                      if (second === "big") {
                        if (secondNumber >= 5) {
                          odds.isChecked = true;
                        }
                      } else if (second === "small") {
                        if (secondNumber < 5) {
                          odds.isChecked = true;
                        }
                      } else if (second === "single") {
                        if (secondNumber % 2 !== 0) {
                          odds.isChecked = true;
                        }
                      } else if (second === "double") {
                        if (secondNumber % 2 === 0) {
                          odds.isChecked = true;
                        }
                      }
                    }
                  } else if (first === "double") {
                    if (firstNumber % 2 === 0) {
                      if (second === "big") {
                        if (secondNumber >= 5) {
                          odds.isChecked = true;
                        }
                      } else if (second === "small") {
                        if (secondNumber < 5) {
                          odds.isChecked = true;
                        }
                      } else if (second === "single") {
                        if (secondNumber % 2 !== 0) {
                          odds.isChecked = true;
                        }
                      } else if (second === "double") {
                        if (secondNumber % 2 === 0) {
                          odds.isChecked = true;
                        }
                      }
                    }
                  }
                }
              } else if (number == first + second) {
                odds.isChecked = true;
              }
            }
          }
        }
      }

      //按合分勾选

      if (this.heFenFilter.length > 0) {
        for (let odds of this.oddsList[this.choiceNav].list) {
          for (let heFen of this.heFenFilter) {
            let number = odds.number.replace(/X/g, "");
            let firstNumber = number.substr(0, 1) * 1;
            let secondNumber = number.substr(1, 1) * 1;
            let yushu = (firstNumber + secondNumber) % 10;
            if (heFen === "single") {
              if (yushu % 2 !== 0) {
                odds.isChecked = true;
              }
            } else if (heFen === "double") {
              if (yushu % 2 === 0) {
                odds.isChecked = true;
              }
            } else {
              if (yushu == heFen) {
                odds.isChecked = true;
              }
            }
          }
        }
      }

      //按输入数字勾选
      if (this.firstFilterInput !== "" && this.secondFilterInput !== "") {
        let firstFilterArr = this.firstFilterInput.split("");
        let secondFilterArr = this.secondFilterInput.split("");
        for (let odds of this.oddsList[this.choiceNav].list) {
          for (let first of firstFilterArr) {
            for (let second of secondFilterArr) {
              let number = odds.number.replace(/X/g, "");
              if (number == first + second) {
                odds.isChecked = true;
              }
            }
          }
        }
      }
    },
    choiceNavHandel(nav) {
      this.choiceNav = nav;
    },
    async getBetList() {
      if (this.initFinished) {
        console.log("userInfo", this.$store.state.userInfo);
        let data = {
          access_token: this.$store.state.userInfo.access_token,
          uid: this.$store.state.userInfo.uid,
          code: this.$store.state.gameInfo[0].code,
          playcode: this.playcode,
        };
        let result = await this.$http.postAxiosMethod("/user/odds", data);
        if (result.code == 0) {
          let reg1 = /^[0-9][0-9]XX/i;
          let reg2 = /^[0-9]X[0-9]X/i;
          let reg3 = /^[0-9]XX[0-9]/i;
          let reg4 = /^X[0-9][0-9]X/i;
          let reg5 = /^X[0-9]X[0-9]/i;
          let reg6 = /^XX[0-9][0-9]/i;
          let reg7 = /^[0-9]XXX[0-9]/i;
          let reg8 = /^X[0-9]XX[0-9]/i;
          let reg9 = /^XX[0-9]X[0-9]/i;
          let reg10 = /^XXX[0-9][0-9]/i;
          this.oddsList.口口XX.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg1.test(item.number);
          });
          this.oddsList.口X口X.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg2.test(item.number);
          });
          this.oddsList.口XX口.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg3.test(item.number);
          });
          this.oddsList.X口口X.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg4.test(item.number);
          });
          this.oddsList.X口X口.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg5.test(item.number);
          });
          this.oddsList.XX口口.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg6.test(item.number);
          });
          this.oddsList.口XXX口.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg7.test(item.number);
          });
          this.oddsList.X口XX口.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg8.test(item.number);
          });
          this.oddsList.XX口X口.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg9.test(item.number);
          });
          this.oddsList.XXX口口.list = result.data.filter((item) => {
            item.money = "";
            item.isChecked = false;
            return reg10.test(item.number);
          });
        }
      }
    },
    choiceBall(ball, flag) {
      ball.isChecked = flag || !ball.isChecked;
      if (this.money) {
        ball.money = this.money;
      }
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.refreshOdds();
      });
    },
    choiceNumber(type, position) {
      if (position == 1) {
        if (this.firstPositionFilter.includes(type)) {
          this.firstPositionFilter.splice(
            this.firstPositionFilter.indexOf(type),
            1
          );
        } else {
          this.firstPositionFilter.push(type);
        }
      } else if (position == 2) {
        if (this.secondPositionFilter.includes(type)) {
          this.secondPositionFilter.splice(
            this.secondPositionFilter.indexOf(type),
            1
          );
        } else {
          this.secondPositionFilter.push(type);
        }
      }
    },
    choiceHeFen(type) {
      if (this.heFenFilter.includes(type)) {
        this.heFenFilter.splice(this.heFenFilter.indexOf(type), 1);
      } else {
        this.heFenFilter.push(type);
      }
    },
    setCheckedMoney() {
      for (let key in this.oddsList) {
        for (let i of this.oddsList[key].list) {
          if (i.isChecked) {
            i.money = this.money;
          }
        }
      }
      this.refreshOdds();
    },
    async bet() {
      if (this.isClose == 0) {
        let betArr = [];
        let bet_str = "";
        this.betList.forEach((item) => {
          betArr.push(`${item.number}:${item.money}`);
        });
        bet_str = betArr.join(",");
        let data = {
          access_token: this.$store.state.userInfo.access_token,
          uid: this.$store.state.userInfo.uid,
          game_code: this.$store.state.gameInfo[0].code,
          key: new Date().getTime(),
          play_type: "zhixuan",
          total_money: this.sum(this.betList, "money"),
          bet_num: this.betList.length,
          bet_str,
          bet_log: "游戏日志",
          bet_qihao: this.$store.state.gameInfo[0].nextQihao,
        };
        let result = await this.$http.postAxiosMethod("/user/bet2", data);
        if (result.code == 0) {
          this.$message({
            iconClass: "fa fa-check-circle",
            customClass: "bet_message",
            type: "success",
            duration: 3000,
            message: "下注成功！",
          });
          this.showComfirmBet = false;
          this.reset();
          setTimeout(() => {
            this.$BUS.$emit("bet");
          }, 500);
        }
      } else {
        document.activeElement.blur();
        this.$alert("已封盘", "提示");
      }
    },
    sum(list, key) {
      let sum = 0;
      for (let i of list) {
        sum += i[key] * 1;
      }
      return sum;
    },
    delBetList(index) {
      this.betList.splice(index, 1);
      if (this.betList.length === 0) {
        this.showComfirmBet = false;
      }
    },
    reset() {
      for (let key in this.oddsList) {
        for (let i of this.oddsList[key].list) {
          i.isChecked = false;
          i.money = "";
        }
      }
      this.firstFilterInput = "";
      this.secondFilterInput = "";
      this.heFenFilter = [];
      this.firstPositionFilter = [];
      this.secondPositionFilter = [];
      this.money = "";
      this.refreshOdds();
    },
    surePreMoney() {
      this.showPreMoneyList = JSON.parse(JSON.stringify(this.preMoney));
      this.showPreMoney = false;
    },
    confirmBet() {
      console.log("confirmBet");
      if (
        this.oddsList[this.choiceNav].list.filter((item) => item.isChecked)
          .length === 0
      ) {
        document.activeElement.blur();
        this.$alert("请选择下注号码", "提示");
        return;
      }
      if (
        this.oddsList[this.choiceNav].list.filter((item) => item.money != "")
          .length === 0
      ) {
        document.activeElement.blur();
        this.$alert("请输入下注金额", "提示");
        return;
      }
      this.betList = JSON.parse(
        JSON.stringify(
          this.oddsList[this.choiceNav].list.filter((item) => {
            return item.isChecked && item.money != "";
          })
        )
      );
      if (this.betList.length > 0) {
        this.showComfirmBet = true;
        this.$nextTick(function () {
          console.log(this.$refs.confirmBet);
          this.$refs.confirmBet.focus();
        });
      }
    },
    refreshOdds() {
      this.oddsList = JSON.parse(JSON.stringify(this.oddsList));
    },
  },
};
</script>

<style lang="scss" scoped>
.ezd-page {
  background: #fff;
  border: 1px solid var(--new-border);
  input[type="text"] {
    border: 1px solid var(--new-border);
  }
  & > .title {
    margin-bottom: 8px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
    border-bottom: 1px solid var(--new-border);
    ul {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      li {
        height: 100%;
        padding: 0 15px;
        cursor: pointer;
        &.active {
          color: #fff;
        }
      }
    }
  }
  & > .content {
    padding-left: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    table {
      width: 20%;
      font-size: 12px;
      &.line1 {
        padding-bottom: 5px;
        border-top: 1px solid var(--new-border);
        border-bottom: 1px solid var(--new-border);
      }
      &:nth-child(1) {
        tr {
          position: relative;
          > .arrow {
            position: absolute;
            left: -10px;
            top: 50%;
            transform: translateY(-50%);
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            border-left: 8px solid var(--new-primary-color);
          }
        }
      }
      tr:nth-child(1) {
        td:nth-child(1) {
          position: relative;
          > .arrow {
            position: absolute;
            left: 0;
            top: 4px;
            transform: translateY(-50%);
            border-top: 5px solid var(--new-primary-color);
            border-bottom: 5px solid transparent;
            border-right: 5px solid transparent;
            border-left: 5px solid var(--new-primary-color);
          }
        }
      }
    }
  }
  .tool-wrapper {
    display: flex;
    font-weight: bold;
    .tool {
      flex: 1;
      display: flex;
      border: 1px solid var(--new-border);
      border-top: none;
      &:not(:last-child) {
        border-right: none;
      }
      .tool-title {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 90px;
        height: 100%;
        text-align: center;
        background: var(--new-bg-table-header-main);
        border-right: 1px solid var(--new-border);
      }
      .tool-content {
        flex: 1;
        .row {
          height: 50%;
          display: flex;
          line-height: 25px;
          &:not(:last-child) {
            // margin-bottom: 5px;
            border-bottom: 1px solid var(--new-border);
          }
          > div {
            padding: 0 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            & > span {
              width: 20px;
              height: 20px;
              border-radius: 4px;
              text-align: center;
              line-height: 20px;
              display: inline-block;
              background: var(--new-bg-table-header-main);
              cursor: pointer;
              font-size: 12px;
              &.active {
                color: var(--new-text-primary-bg);
                background-color: var(--new-bg-table-active);
              }
            }
          }
        }
      }
    }
  }
  .ball-td {
    td {
      height: 30px;
      border-right: 1px solid var(--new-border);
      border-bottom: 1px solid var(--new-border);
      &:nth-child(1) {
        background-color: var(--new-bg-table-header-main);
      }
    }
    &.active {
      td:not(:first-child) {
        background: var(--new-bg-table-active) !important;
      }
    }
  }
  .ball-td:hover {
    td {
      background-color: var(--new-bg-table-header-main) !important;
    }
  }
  .bottom—tool {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 13px 0;
    font-size: 13px;
    color: var(--new-text-info);
    font-weight: bold;
    .input-money {
      margin-right: 10px;
      margin-left: 10px;
      width: 71px;
      height: 26px;
      opacity: 0.7;
      border-color: var(--new-border);
    }
    .choice-money {
      display: inline-block;
      padding: 0 10px;
      color: var(--new-primary-color);
      line-height: 24px;
      margin: 0 2.5px;
      border-radius: 2px;
      cursor: pointer;
      background: var(--new-bg-table-header-main);
    }
    .add-btn {
      display: inline-block;
      margin: 0 88px 0 18px;
      width: 30px;
      text-align: center;
      background: var(--sub-nav-bg-color);
      border-radius: 2px;
      color: #fff;
      font-size: 20px;
      cursor: pointer;
    }
    .btn-group {
      & > input {
        margin: 0 10px;
        // cursor: pointer;
        // margin-right: 14px;
        // width: 60px;
        // padding: 4px 0;
        // font-size: 14px;
        // border-radius: 2px;
        // color: #fff;
        &:nth-child(1) {
          // margin-right: 30px;
        }
        // &:nth-child(2) {
        //   background: linear-gradient(90deg, #01d5c1, #00b6b8, #0096ac);
        // }
      }
    }
    & > span {
      font-size: 12px;
    }
  }
  .confirm-bet-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
  }
  .confirm-bet {
    outline: none;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 516px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-bottom: 1px solid #bad4e8;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    font-size: 13px;
    border-radius: 20px;
    overflow: hidden;
    z-index: 2000;
    h1.title {
      padding: 20px 0;
      position: relative;
      text-align: center;
      line-height: 24px;
      font-size: 24px;
      font-weight: normal;
      background: var(--new-bg-white);
      text-align: center;
      color: var(--new-text-active);
      i {
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        position: absolute;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        color: var(--new-text);
      }
    }
    .content {
      max-height: 280px;
      overflow: auto;
      padding: 0 15px;
      padding-top: 0;
      table {
        width: 100%;
      }
      .money {
        width: 55px;
        height: 22px;
        border-radius: 2px;
        padding: 0 5px;
      }
      .del-bet {
        margin: auto;
        cursor: pointer;
        width: 22px;
        height: 22px;
        text-align: center;
        line-height: 22px;
        border-radius: 50%;
        // background-color: #ff3737;
        color: #000;
        &:hover {
          color: var(--primary-active-text-color-2);
        }
        i {
          font-weight: bold;
        }
      }
      .bc {
        text-align: left;
        background: linear-gradient(to bottom, #fff, #bad4e8);
      }
      table {
        width: 100%;
        font-size: 13px;
        border: 1px solid var(--new-border);
        border-right: none;
        border-bottom: none;
        tr {
          border: 1px solid var(--new-border);
        }
        th,
        td {
          height: 30px;
          line-height: 30px;
          text-align: center;
          // &:not(:last-child) {
          border-right: 1px solid var(--new-border);
          border-bottom: 1px solid var(--new-border);
          // }
        }
        &.report-detail {
        }
        thead {
          background: var(--new-bg-table-header-main);
        }
        // th {
        //   font-weight: bold;
        //   // color: #401e1e;
        //   &.bg {
        //     background: #f3f5fc;
        //   }
        // }
        tr:not(.sum) {
          cursor: pointer;
        }
        .sum {
          // background-color: #f3f5fc;
          td {
            font-weight: bold;
            // color: #401e1e;
          }
        }
      }
    }
    .btn-group {
      margin-top: 20px;
      text-align: center;
      input[type="button"] {
        &:nth-child(1) {
          margin-right: 30px;
        }

        // width: 101px;
        // height: 34px;
        // border-radius: 2px;
        // color: #fff;
        // font-size: 16px;
        // &:nth-child(1) {
        //   background: linear-gradient(90deg, #01d5c1, #00b5b8, #0096ac);
        // }
        // &:nth-child(2) {
        //   background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
        // }
      }
    }
  }
}
</style>
